export enum HttpStatusCode {
	Idle = 100,
	Loading = 102,
	OK = 200,
	NoContent = 204,
	BadRequest = 400,
	Unauthorized = 401,
	Forbidden = 403,
	NotFound = 404,
	InternalServerError = 500,
}
